export const CASES = {
  UPDATE_JOBS: "LICENSING_JOBS/UPDATE_JOBS",
  UPDATE_JOBS_SEARCH_FORM: "LICENSING_JOBS/UPDATE_JOBS_SEARCH_FORM",
  UPDATE_JOBS_FORM: "LICENSING_JOBS/UPDATE_JOBS_FORM",
  CLEAR_JOBS: "LICENSING_JOBS/CLEAR_JOBS",
  CLEAR_JOB_VIEW_MODAL: "LICENSING_JOBS/CLEAR_JOB_VIEW_MODAL",
  CLEAR_JOB_TASKS_MODAL: "LICENSING_JOBS/CLEAR_JOB_TASKS_MODAL",
};
